export const mapAddressInfo = (info, type, name = "short_name") =>
  info
    ?.map((item) => (item?.types?.includes(type) ? item[name] : null))
    .filter(Boolean)[0];

export const parseGoogleAddressLocation = (info) => {
  if (!info?.length) return null;

  const city =
    mapAddressInfo(info, "locality") ||
    mapAddressInfo(info, "administrative_area_level_2") ||
    mapAddressInfo(info, "sublocality") ||
    mapAddressInfo(info, "postal_town") ||
    mapAddressInfo(info, "neighborhood");

  return {
    city,
    state: mapAddressInfo(info, "administrative_area_level_1"),
    zip: mapAddressInfo(info, "postal_code"),
    country: mapAddressInfo(info, "country"),
  };
};

export const parseGoogleStreetAddress = (info) => {
  const streetNumber = mapAddressInfo(info, "street_number");
  const route = mapAddressInfo(info, "route");
  return [streetNumber, route].filter(Boolean).join(" ") || null;
};

export const isValidGoogleAddressLocation = (location) =>
  !!(location?.country && location?.state && (location?.city || location?.zip));
